export default __webpack_public_path__ + "static/media/not-found.ce1061c5632d070072fd8bd1ed48c49c.svg";